import { useEffect, useState } from 'react';
import { ITypedBaseResponse } from '@nkr/models/base-response';
import { IStrongBoxFilter, IStrongBoxCenterOrderListing } from '@nkr/models/strong-box';
import { AuthActionCreators } from '@nkr/store/authorization';
import { useAppHookContext } from '@nkr/utils/rest-api';

interface IRetVal {
    list: IStrongBoxCenterOrderListing[],
    loading: boolean,
    error: string,
    checkStatus: (strongBoxOrderId: number) => void
}

const useStrongBoxOrders = (filter?: IStrongBoxFilter): IRetVal => {
    const { dispatch } = useAppHookContext();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IStrongBoxCenterOrderListing[]>([]);

    useEffect(() => {
        if (filter) {
            setLoading(true);
            setError('');

            const fetchData = async () => {
                let config = {
                    url: `${__API__}/strongbox/order/search`,
                    data: filter
                };

                try {
                    const response: ITypedBaseResponse<IStrongBoxCenterOrderListing[]> = await dispatch(AuthActionCreators.apiPost(config));

                    if (response && response.data.results && response.data.success) {
                        setList(response.data.results);
                    } else {
                        setError('Unable to load data');
                        setList([]);
                    }
                } catch (err) {
                    setList([]);
                    setError(err);
                } finally {
                    setLoading(false);
                }
            }

            fetchData();
        }
    }, [filter]);

    const checkStatus = (strongBoxOrderId: number) => {
        const fetchData = async () => {
            let config = {
                url: `${__API__}/strongbox/order/${strongBoxOrderId}/check-status`
            };

            try {
                const response: ITypedBaseResponse<null> = await dispatch(AuthActionCreators.apiGet(config));

                if (response && response.data.success) {

                } else {
                    setError('Unable to load data');
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    };

    return { list, loading, error, checkStatus }
}

export default useStrongBoxOrders;